var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.913 6.21051C16.5274 6.21051 18.0756 6.78379 19.2171 7.80423C20.3587 8.82467 21 10.2087 21 11.6518V18H16.942V11.6518C16.942 11.1708 16.7282 10.7094 16.3477 10.3693C15.9672 10.0291 15.4511 9.83804 14.913 9.83804C14.3749 9.83804 13.8588 10.0291 13.4783 10.3693C13.0978 10.7094 12.884 11.1708 12.884 11.6518V18H8.82605V11.6518C8.82605 10.2087 9.46735 8.82467 10.6089 7.80423C11.7504 6.78379 13.2986 6.21051 14.913 6.21051V6.21051Z",
    stroke: "#4800BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34783 7.89478H1V18H5.34783V7.89478Z",
    stroke: "#4800BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5C4.10457 5 5 4.10457 5 3C5 1.89543 4.10457 1 3 1C1.89543 1 1 1.89543 1 3C1 4.10457 1.89543 5 3 5Z",
    stroke: "#4800BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.006e424c2dcf3a00ae31c4eea4a990bb.svg";
export { ForwardRef as ReactComponent };